import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { popupSettingsApi } from '@/services/api';
import { PopupSetting } from '@/types';

const STORAGE_KEY = 'quote_popup_shown';

export const useQuotePopup = () => {
    const { i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [isDismissed, setIsDismissed] = useState(false);
    const [settings, setSettings] = useState<PopupSetting | null>(null);

    // Fetch settings from Strapi
    useEffect(() => {
        popupSettingsApi.get(i18n.language).then(({ data }) => {
            if (data?.data) {
                setSettings(data.data as unknown as PopupSetting);
            }
        }).catch(() => {});
    }, [i18n.language]);

    const showPopup = useCallback(() => {
        if (!isDismissed) {
            setIsVisible(true);
        }
    }, [isDismissed]);

    const hidePopup = useCallback(() => {
        setIsVisible(false);
        setIsDismissed(true);
    }, []);

    // Timed popup display — only when settings are loaded and popup is enabled
    useEffect(() => {
        if (!settings || !settings.is_enabled || isDismissed) return;

        const timer = setTimeout(() => {
            showPopup();
        }, settings.show_delay);

        return () => clearTimeout(timer);
    }, [settings, isDismissed, showPopup]);

    return {
        isVisible,
        settings,
        showPopup,
        hidePopup,
    };
};
